import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import ReactDOM from 'react-dom';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';

import { AuthProvider } from 'src/Firebase/context';

import { EnqueueAlertProvider } from './contexts/EnqueueAlertContext';

import App from './App';
import theme from './theme';

import * as serviceWorker from './serviceWorker';
import axios from 'axios';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import installApiTracing from 'src/utils/installApiTracing';
import { ADMIN_ENDPOINT } from 'src/config';

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 0.2,
  });
}

installApiTracing({
  client_app: 'meny-admin',
  client_version: process.env.NODE_ENV,
  axios_instance: axios,
  api_prefixes: [ADMIN_ENDPOINT],
});


if (process.env.NODE_ENV != 'development') {
  console.log = () => {};
  console.assert = () => {};
  console.warn = () => {};

  if (window.location.href.search('web.app') == -1) {
    console.debug = () => {};
    console.error = () => {};
  }

  alert = () => {};
}

const queryClient = new QueryClient();

ReactDOM.render(
  <>
    <Suspense fallback={<div>Loading...</div>}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <BrowserRouter>
              <EnqueueAlertProvider>
                <App />
              </EnqueueAlertProvider>
            </BrowserRouter>
          </ThemeProvider>
        </QueryClientProvider>
      </AuthProvider>
    </Suspense>
  </>,
  document.querySelector('#root')
);

serviceWorker.unregister();
